/**
 * PDP Creator Testimonials Custom Element
 * Self-initializing, editor-friendly web component wrapping the creator testimonials slider.
 */
class PdpCreatorTestimonials extends HTMLElement {
  connectedCallback() {
    const carousel = this.querySelector('[data-testimonials-carousel]');
    if (!carousel) return;

    const track = carousel.querySelector('[data-testimonials-track]');
    if (!track) return;

    const slides = track.querySelectorAll('.pdp-creator-testimonials__slide');
    const dots = carousel.querySelectorAll('[data-testimonials-dot]');
    const prevBtn = carousel.querySelector('[data-testimonials-prev]');
    const nextBtn = carousel.querySelector('[data-testimonials-next]');
    let current = 0;
    const total = slides.length;

    if (total === 0) return;

    const goTo = (index) => {
      current = (index + total) % total;
      track.style.transform = `translateX(-${current * 100}%)`;
      
      dots.forEach((dot, i) => {
        dot.classList.toggle('pdp-creator-testimonials__dot--active', i === current);
      });
    };

    if (prevBtn) {
      prevBtn.addEventListener('click', () => goTo(current - 1));
    }
    
    if (nextBtn) {
      nextBtn.addEventListener('click', () => goTo(current + 1));
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', function() {
        goTo(Number(this.getAttribute('data-testimonials-dot')));
      });
    });

    goTo(0);
  }
}

if (!customElements.get('pdp-creator-testimonials')) {
  customElements.define('pdp-creator-testimonials', PdpCreatorTestimonials);
}
